import React from 'react';
import PropTypes from 'prop-types';
import Adcopy from './adcopy';
import Parallax from './parallax';
import PhotoGallery from './photo-gallery';
import ShAgents from './sh-agents';
import ShFeatures from './sh-features';
import ShFloorplans from './sh-floorplans';
import ShGoogleMap from './sh-google-map';
import ShInquireForm from './sh-inquire-form';

import './sh-listing-detail.scss';
import ShNews from './sh-news';
import ShVideo3dTours from './sh-video-3d-tours';
import ShVideoGallery from './sh-video-gallery';
import ShOpenhouse from './sh-openhouse';

class ShDetailPage extends React.Component {
  render() {
    const listing = this.props.listing;

    return (
      <div className="sh-listing-detail">
        <div className="content">
          <Parallax listing={listing} />
          <div className="full_width container">
            <div className="full_width_inner row">
              <ShOpenhouse openhouses={listing.openhouses} />
              <Adcopy listing={listing} />
              <ShVideoGallery videos={listing.videos} />
              <PhotoGallery images={listing.images} />
              <ShVideo3dTours listing={listing} />
              <ShFeatures listing={listing} />
              <ShFloorplans listing={listing} />
              <ShNews listing={listing} />
              <ShGoogleMap listing={listing} />
              <ShAgents entity={this.props.entity} listing={listing} />
              <ShInquireForm entity={this.props.entity} listing={listing} agentEmail={this.props.entity.emailAddress} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ShDetailPage.propTypes = {
  listing: PropTypes.object.isRequired,
  entity: PropTypes.object.isRequired,
};

export default ShDetailPage;


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-detail-page.js